/**
 * Marcas de la franja institucional. Cada una conserva un guiño a su
 * identidad (tamaño / color / peso / itálica), como en el piloto V4.
 *
 * `className` trae el tamaño completo (base y md) para que no compita con
 * ninguna clase del contenedor.
 */
const BASE_SIZE = "text-[13px] md:text-sm";
const LEAD_SIZE = "text-lg md:text-xl tracking-[-.05em]";

export const brands = [
	{ name: "Hidracolor", className: `${LEAD_SIZE} font-extrabold` },
	{ name: "Küül", className: `${LEAD_SIZE} font-extrabold text-[#4f2683]` },
	{ name: "WMARK", className: `${BASE_SIZE} font-extrabold` },
	{ name: "Dompel", className: `${BASE_SIZE} font-semibold text-[#bd3678]` },
	{ name: "Bluesky", className: `${BASE_SIZE} font-extrabold italic text-[#2478b6]` },
	{ name: "Depilflax", className: `${BASE_SIZE} font-bold text-[#343e93]` },
	{ name: "Starpil", className: `${BASE_SIZE} font-extrabold tracking-[.01em] text-[#d62e76]` },
	{ name: "Razorline", className: `${BASE_SIZE} font-medium uppercase tracking-[.05em] text-[#111]` }
];

export default brands;
